import { MtsResponse } from '@/store/slices/it-process/application-management/mts/mtsSlice'

export interface TokenUpdate {
    id: string
    key: string
    tokenizedValue: string
}

export const updateTokensInMtsList = (
    mtsList: MtsResponse[],
    tokenUpdates: TokenUpdate[],
): MtsResponse[] => {

    const updatedList = mtsList.map((item) => {
        // Try to find a matching token update
        const tokenUpdate = tokenUpdates.find(
            (t) => t.key === item.id.toString() || t.key === item.name,
        )

        if (!tokenUpdate) {
           
            return item
        }

        const updatedItem = {
            ...item,
            tokens: [
                ...(item.tokens || []).filter((t) => t.key !== tokenUpdate.key),
                {
                    id: tokenUpdate.id,
                    key: tokenUpdate.key,
                    tokenizedValue: tokenUpdate.tokenizedValue,
                },
            ],
        }

        return updatedItem
    })

    return updatedList
}
